
import { IAisUrls, IAuthUrls, IBaseUrls, IFeaturesUrls, IMaps, IUsersUrls } from "./interfaces"

class Urls {

  private mainUrl: string
  private baseUrls: IBaseUrls

  constructor() {
    
    this.mainUrl = this.mainUrlBuilder(window.location)
    this.baseUrls = this.baseUrlBuilder()
    
  }

  private baseUrlBuilder(): IBaseUrls {
    const urls: IBaseUrls = {
      usersUrl: this.mainUrl + "api/users/",
      authUrl: this.mainUrl + "api/auth/",
      aisUrl: this.mainUrl + "ais/",
      customFeaturesUrl: this.mainUrl + "api/custom_features/",
      chartFeaturesUrl: this.mainUrl + "api/chart_features/",
      mapsUrl: this.mainUrl + "maps/"
    }
    return urls
  }

  private mainUrlBuilder = (location: Location) => {
    const splitArray = location.pathname.split("/");
    const virtualUrl = splitArray[splitArray.length - 2];
    return virtualUrl
      ? `${location.origin}/${virtualUrl}/`
      : `${location.origin}/`;
  };

  get aisUrls(): IAisUrls {
    const aisUrls = this.baseUrls.aisUrl
    return {
      targets: aisUrls + "targets/",
      atons: aisUrls + "atons/",
      basestations: aisUrls + "bs/",
      grupos: aisUrls + "grupos/", // grupos
    };
  }

  get featuresUrls(): IFeaturesUrls {
    const customFeaturesUrls = this.baseUrls.customFeaturesUrl
    const chartFeaturesUrls = this.baseUrls.chartFeaturesUrl
    return {
      fixedPlatforms: customFeaturesUrls + "plataformas_fijas/",
      mobilePlatforms: customFeaturesUrls + "plataformas_moviles/",
      linealPlatforms: customFeaturesUrls + "plataformas_lineas/",
      channels: customFeaturesUrls + "canales/",
      customAnchorages: customFeaturesUrls + "fondeaderos/",
      chartAnchorages: chartFeaturesUrls + "achare/",
      ducts: customFeaturesUrls + "ductos/",
    }
  }
  
  get authUrls(): IAuthUrls {
    const authUrls = this.baseUrls.authUrl
    return {
      crsfUrl: authUrls + "login-set-cookie/",
      loginUrl: authUrls + "login/",
      logoutUrl: authUrls + "logout/",
      validateUrl: authUrls + "validate/",
      tokenList: authUrls + "available_tokens/",
      assignToken: authUrls + "assign_token/",
    }
  }
  
  get userUrls(): IUsersUrls {
    const userUrls = this.baseUrls.usersUrl
    return {
      me: userUrls + "me/",
      admin: userUrls + "admin/all_users/",
    }
  }

  get mapsUrls(): IMaps {
    return {
      osm: {
        url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      },
      darkmap: {
        url:
          "https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png",
        attribution:
          '&copy; <a href="https://stadiamaps.com/">Stadia Maps</a>, &copy; <a href="https://openmaptiles.org/">OpenMapTiles</a> &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors',
      },
      topomap: {
        url: "http://mt.google.com/vt/lyrs=s&x={x}&y={y}&z={z}",
        attribution:
          'Map data: &copy; <a href="https://www.google.com.mx">Google</a> contributors',
      },
      marine: this.baseUrls.mapsUrl
    }
  }
}

export default new Urls()


/*
import { IAisUrls, IAuthUrls, IBaseUrls, IFeaturesUrls, IMaps, IUsersUrls } from "./interfaces"

class Urls {

  private baseUrls: IBaseUrls

  constructor() {
    this.baseUrls = this.baseUrlBuilder()
  }

  private baseUrlBuilder(): IBaseUrls {
    // 👉 base configurable por entorno
    //const base = import.meta.env.VITE_API_BASE
    const base = "/api/"
    
    return {
      usersUrl: base + "users/",
      authUrl: base + "auth/",
      aisUrl: "/" + "ais/",
      customFeaturesUrl: base + "custom_features/",
      chartFeaturesUrl: base + "chart_features/",
      mapsUrl: base + "maps/"
    }
  }

  get aisUrls(): IAisUrls {
    const aisUrls = this.baseUrls.aisUrl
    return {
      targets: aisUrls + "targets/",
      atons: aisUrls + "atons/",
      basestations: aisUrls + "bs/",
      grupos: aisUrls + "grupos/", // grupos
    };
  }

  get featuresUrls(): IFeaturesUrls {
    const customFeaturesUrls = this.baseUrls.customFeaturesUrl
    const chartFeaturesUrls = this.baseUrls.chartFeaturesUrl
    return {
      fixedPlatforms: customFeaturesUrls + "plataformas_fijas/",
      mobilePlatforms: customFeaturesUrls + "plataformas_moviles/",
      linealPlatforms: customFeaturesUrls + "plataformas_lineas/",
      channels: customFeaturesUrls + "canales/",
      customAnchorages: customFeaturesUrls + "fondeaderos/",
      chartAnchorages: chartFeaturesUrls + "achare/",
      ducts: customFeaturesUrls + "ductos/",
    }
  }
  
  get authUrls(): IAuthUrls {
    const authUrls = this.baseUrls.authUrl
    return {
      crsfUrl: authUrls + "login-set-cookie/",
      loginUrl: authUrls + "login/",
      logoutUrl: authUrls + "logout/",
      validateUrl: authUrls + "validate/",
      tokenList: authUrls + "available_tokens/",
      assignToken: authUrls + "assign_token/",
    }
  }

  get userUrls(): IUsersUrls {
    const userUrls = this.baseUrls.usersUrl
    return {
      me: userUrls + "me/",
      admin: userUrls + "admin/all_users/",
    }
  }

  get mapsUrls(): IMaps {
    return {
      osm: {
        url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      },
      darkmap: {
        url:
          "https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png",
        attribution:
          '&copy; <a href="https://stadiamaps.com/">Stadia Maps</a>, &copy; <a href="https://openmaptiles.org/">OpenMapTiles</a> &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors',
      },
      topomap: {
        url: "http://mt.google.com/vt/lyrs=s&x={x}&y={y}&z={z}",
        attribution:
          'Map data: &copy; <a href="https://www.google.com.mx">Google</a> contributors',
      },
      marine: this.baseUrls.mapsUrl
    }
  }
}

export default new Urls()
*/